import { useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import createIcon from '../../../../static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';

export default function TransportPricingList(): JSX.Element {
  const history = useHistory();
  const url = `${API_URL}/transport-pricings/get`;
  const onRowClick = (rowInfo) => {
    history.push(`/transport-pricings/edit/${rowInfo.dataItem.id}`);
  };
  const StatefullGrid = withState(Grid, url, { onRowClick });

  const countryCell = (p) => {
    return <td>{p?.dataItem?.country?.name}</td>;
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Transport Pricings"
        titleRight="Create"
        onRightHandler={(): void => history.push('/transport-pricings/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid>
          <GridColumn field="countryId" title="Country" cell={countryCell} />
          <GridColumn field="inStandard" title="in Standard" />
          <GridColumn field="outStandard" title="out Standard" />
          <GridColumn field="inReefer" title="in Reefer" />
          <GridColumn field="outReefer" title="out Reefer" />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
